"use client"

import { useUIBuilderLocaleStore } from "@/(admin)/modules/ui-builder/store/useUIBuilderLocaleStore"
import { useProductsByEans } from "@/hook/use-products-by-eans"
import { useDebounce } from "@/hook/useDebounce"
import { ComponentConfig } from "@measured/puck"
import { useParams } from "next/navigation"
import { useMemo } from "react"
import { twMerge } from "tailwind-merge"
import { TamdaExpressProductListContent } from "./components/TamdaExpressProductListContent"
import { TamdaExpressProductListProps } from "./types"

export const RenderConfig: ComponentConfig<TamdaExpressProductListProps> = {
  render: ({ eanIds, title, className }) => {
    const params = useParams()
    const storeLocale = useUIBuilderLocaleStore(state => state.locale)
    const locale = (params?.locale as string) || storeLocale || "vi"
    const debouncedEanIds = useDebounce(eanIds, 900)

    const validEanIds = useMemo(() => {
      if (!debouncedEanIds || typeof debouncedEanIds !== "string") return []

      const validEanIds = debouncedEanIds
        .split("\n")
        .map(ean => ean.trim())
        .filter(ean => {
          // Validate EAN ID: chỉ số, độ dài hợp lý (thường là 8, 12, 13, 14 chữ số)
          const isValidFormat = /^\d+$/.test(ean)
          const isValidLength = ean.length >= 8 && ean.length <= 14
          return isValidFormat && isValidLength && ean.length > 0
        })

      return validEanIds
    }, [debouncedEanIds])

    const { products, loading, error } = useProductsByEans(validEanIds.length > 0 ? validEanIds : undefined)

    return (
      <div className={twMerge("container mx-auto max-w-[1320px] px-4 py-8", className)}>
        <TamdaExpressProductListContent products={products} loading={loading} error={error} title={title} locale={locale} />
      </div>
    )
  },
}
